import { Badge, Text } from '@mantine/core';
import {
    payoutWorkingStatusColors,
    type PayoutTrader,
    formatPayoutTrader,
    payoutTraderStatusColors,
} from '~/entities/payout';
import { type TableCell, type TableData, type TableRow } from '~/shared/ui/Table';

const prepareHeaders: TableCell[] = [
    { key: 'id', content: 'ID', ta: 'center' },
    { key: 'username', content: 'Username', ta: 'center' },
    { key: 'traderName', content: 'Имя трейдера', ta: 'center' },
    { key: 'status', content: 'Статус', ta: 'center' },
    { key: 'workingStatus', content: 'Рабочий статус', ta: 'center' },
    { key: 'bankAccountId', content: 'ID Счета', ta: 'center' },
    { key: 'checkEmail', content: 'Email', ta: 'center' },
];

type PrepareTableDataProps = {
    traders?: PayoutTrader[];
};

const prepareRows = ({ traders }: PrepareTableDataProps): TableRow<PayoutTrader>[] => {
    if (!traders) {
        return [];
    }

    return traders.map((trader) => ({
        key: trader.id?.value ?? 0,
        cells: [
            { key: 'id', content: <Text ta='center'>{trader.id?.value ?? '-'}</Text> },
            { key: 'username', content: <Text ta='center'>{trader.username ?? '-'}</Text> },
            { key: 'traderName', content: <Text ta='center'>{trader.traderName?.value ?? 'Не указано'}</Text> },
            {
                key: 'status',
                content: trader.status ? (
                    <Text
                        ta='center'
                        component='div'
                    >
                        <Badge color={payoutTraderStatusColors[trader.status!]}>
                            {formatPayoutTrader.status(trader.status!)}
                        </Badge>
                    </Text>
                ) : null,
            },
            {
                key: 'workingStatus',
                content: trader.workingStatus ? (
                    <Text
                        component='div'
                        ta='center'
                    >
                        <Badge color={payoutWorkingStatusColors[trader.workingStatus]}>
                            {formatPayoutTrader.workingStatus(trader.workingStatus)}
                        </Badge>
                    </Text>
                ) : null,
            },
            { key: 'bankAccountId', content: <Text ta='center'>{trader.bankAccountId ?? '-'}</Text> },
            { key: 'checkEmail', content: <Text ta='center'>{trader.checkEmail?.value ?? '-'}</Text> },
        ],
        item: trader,
    }));
};

export const createTableData = ({ traders }: PrepareTableDataProps): TableData<PayoutTrader> => {
    return {
        head: prepareHeaders,
        rows: prepareRows({ traders }),
        caption: traders?.length === 0 ? 'Трейдеров нет' : undefined,
    };
};
